import { Component } from '@angular/core';
import { Events, IonicPage, NavController, NavParams,LoadingController } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
import { AboutPage } from '../about/about';
import { AccountSummaryPage } from '../account-summary/account-summary';
import { CalculatorPage } from '../calculator/calculator';
import { CommingSoonPage } from '../comming-soon/comming-soon';
import { HomePage } from '../home/home';
import { InvestRateHistoryPage } from '../invest-rate-history/invest-rate-history';
import { LoginPage } from '../login/login';
import { PaymentsPage } from '../payments/payments';
import { PersonalDetailsPage } from '../personal-details/personal-details';
import { RaisedIssuesPage } from '../raised-issues/raised-issues';
import { ServiceRequestPage } from '../service-request/service-request';
import { Observable } from "rxjs/Observable";
import 'rxjs/add/observable/forkJoin'

/**
 * Generated class for the DashBoardPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-dash-board',
  templateUrl: 'dash-board.html',
})
export class DashBoardPage {
  tab1Root=AccountSummaryPage
  tab2Root = PaymentsPage
  tab3Root=InvestRateHistoryPage
  tab4Root = ServiceRequestPage
  tab5Root = PersonalDetailsPage
  tab6Root=  RaisedIssuesPage
  itemD:any={"abc":1} 
  mobile:any;
  loanNumber:any;
  arrResponce: any;
  arrResponceCustomerData: any=[];
  arrResponceTBD:any;
  arrResponceEmiPEmi:any;
  arrResponceOd:any;
  addressDetails:any;
  currentloanstatus:boolean=true;
  lan:any=""

  /*******************Chat parameter*****************/
   



  constructor(public loadingCtrl: LoadingController,public navtrl: NavController, public navParams: NavParams,
    private cp:CommonProvider,public events:Events) {
    this.mobile = this.navParams.get("mobile");
    this.itemD.abc=this.mobile;
    this.loanNumber = this.navParams.get("loan");
    // this.getLoanDetails(this.mobile,this.loanNumber)
    this.getLightApiData();
  }

  ionViewDidLoad() {
    //////console.log('ionViewDidLoad DashBoardPage');
    // this.lan=this.navParams.get("loan")
    this.getLightApiData();
    if(!localStorage.getItem("defaultPhoneLength")){
      localStorage.setItem("phoneLength","10");
    }else{
      localStorage.setItem("phoneLength",localStorage.getItem("defaultPhoneLength"));
      
    }
  }
  getLoanDetailsByLanNumber(lannumber){
    this.loanNumber = lannumber;
    // setTimeout(this.getLightApiData(),1000)
    this.getLightApiData();
    this.getLightApiData();

  }
  getLoanDetails(loan,customer_code){
    //console.log(loan,customer_code,"LLLL");
  let loading = this.loadingCtrl.create({
    content: 'Please wait...'
  });
  loading.present();
  let myTopicApi = this.cp.getDashBoardApiData(loading,loan,customer_code);
  let myarticlApi = this.cp.getDashBoardTrancheAndBankDetailsApiData(loading,loan,customer_code);
  let myPicksAPi = this.cp.getDashBoardEmiPMiApiData(loading,loan,customer_code);
  let odChargesAPi = this.cp.getODChargesDetails(loading,loan,customer_code);
  this.addressDetails=[];
  this.arrResponce={}
  Observable.forkJoin([myTopicApi, myarticlApi, myPicksAPi,odChargesAPi])
  .subscribe((res:any) => {
    loading.dismiss();
    this.arrResponce=JSON.parse(res[0]).Payload;
    //console.log(this.arrResponce,"dsds");
    this.arrResponceTBD=JSON.parse(res[1]).Payload;
    this.arrResponceEmiPEmi=JSON.parse(res[2]).Payload;
    //console.log(this.arrResponceEmiPEmi,"this.arrResponceEmiPEmi");
    this.arrResponceOd=JSON.parse(res[3]).Payload.overDueChargesInfo.responseParameters;
    ////console.log("this.arrResponce",this.arrResponceEmiPEmi);
    
    this.arrResponce.paymentMode=JSON.parse(res[3]).Payload.overDueChargesInfo.responseParameters;
    if(this.arrResponce.loanParameterDetail.responseParameters[0].loanstatus=='Active'){
      this.currentloanstatus=false;
    }else{
      this.currentloanstatus=true;
    }

    this.addressDetails.push(this.arrResponce.addressDetail.responseParameters.filter((res:any)=>{
      return res.addresstype == 'CURRES'
    }))
    this.addressDetails.push({"interestratetype":this.arrResponce.loanParameterDetail.responseParameters[0].interestratetype});
    this.addressDetails.push(this.arrResponceTBD.bankInfo);
    // let additionalData:any=[];
    // this.additionalData=this.addressDetails[0].filter((res:any)=>{
    //   return res.applicanttype=="Applicant"

    // });
 
    //////console.log("address details here ",this.addressDetails);
    /***********************Chat with LAN user**********************************/
      // this.cust_number = this.additionalData[0].mobile;
      // this.cust_name = this.additionalData[0].customername;
      // this.cust_email = this.additionalData[0].emailid;
      // var chatDiv = document.getElementById("chatMainDiv");
       
      //   if(chatDiv){
      //     document.getElementById("chatMainDiv").style.display = "block";
         
      //     this.callWebChat(this.cust_name, this.cust_email, this.cust_number);
      //   }
        
    /***************************End Chat*****************************/

    if(this.arrResponce.transactionDetails){
      this.arrResponce.transactionDetails=this.arrResponceTBD
    }else{
      this.arrResponce.transactionDetails=[];
      this.arrResponce.transactionDetails=this.arrResponceTBD
    }
    this.events.publish('tabsEventDataArrResponceEmiPEmi:created',this.arrResponceEmiPEmi , Date.now());
    this.events.publish('tabsEventData:created',this.arrResponce , Date.now());
    this.events.publish('TrancheAndBankDetails:created',this.arrResponceTBD , Date.now());
     
     
     
  }) 
   
   
   
  }
  getLightApiData() {
    let loading = this.loadingCtrl.create({
    content: 'Please wait...'
  });
  loading.present();
    let responcePromice = this.cp.getLightApiData(loading,this.mobile);
    responcePromice.then((res: any) => {
      loading.dismiss()
      var res = JSON.parse(res);
      //////console.log("loan number",res);
      // this.arrResponce = res.Payload.leads;
      if (res.Payload.ibhfl_customerloans) {
        this.arrResponceCustomerData = res.Payload.ibhfl_customerloans;
        var data=this.arrResponceCustomerData.filter((res:any)=>{
          return res.ibhfl_name==this.loanNumber
        })
        ////console.log("JSON.stringify(data) loanNumber",JSON.stringify(data));
        
        localStorage.setItem("existingLoan",JSON.stringify(data))
        if(data.length>0){
          localStorage.setItem("cc",data[0].ibhfl_name);
          localStorage.setItem("ibhfl_customerloanid",data[0].ibhfl_customerloanid);
          
          this.getLoanDetails(data[0].ibhfl_name,data[0].customercode)
        }
        
      }
      

    }).catch(err => {
    //////console.log(err)
    })
  }
 

}



// WEBPACK FOOTER //
// ./src/pages/dash-board/dash-board.ts